import React, { Component, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grow} from  '@material-ui/core';
import clsx from 'clsx';
import {setErrorAndReloadModalMessage} from './../../menu/menu.actions';

const styles = theme => ({
    modal: {
        '& .MuiPaper-root': {
            width: '350px !important',
        }
    },
    modalTitle: {
        textAlign: 'center',
        backgroundColor: "rgb(203,65,2)",
        color: 'white',
        boxShadow: '0 1px 5px 0px black',
        '& .MuiTypography-root': {
            fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
        }
    },
    dialogContent: {
        'background-position': 'center bottom',
        'background-size': 'cover',
    },
    dialogContentText: {
        paddingTop: 10,
    },
    modalTypesBtns: {
        float: 'right'
    },
});

class ChoosePlaceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
        }
    }

    onConfirm = () => {
        this.props.setErrorAndReloadModalMessage("");
        window.location.reload();
    }

    render() {
        const { classes, fullWidth = true, maxWidth = 'xs', open, handleClose, translations } = this.props;

        return (
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={this.props.errorAndReloadModalMessage.length > 0}
                // open={true}
                // onClose={onClose}
                aria-labelledby="max-width-dialog-title"
                TransitionComponent={Grow}
                data-class="dialog-container"
            >
                <DialogTitle id="max-width-dialog-title" className={classes.modalTitle} data-class="dialog-title-container">
                    {translations.messages && translations.messages.errors && translations.messages.errors.error || ''}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText className={classes.dialogContentText}>
                        {this.props.errorAndReloadModalMessage}
                        {/* Опитвате да поръчате продукти от друг обект. Страницата ще бъде презаредена. Моля поръчайте отново. Извиняваме се за неудобството :) */}
                        
                        <br/>
                        <br/>
                        <Button variant="contained" className={clsx(classes.modalTypesBtns)}
                            onClick={this.onConfirm}>
                            Разбрах
                        </Button>
                    </DialogContentText>
                </DialogContent>

            </Dialog>
        );
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        errorAndReloadModalMessage: state.menu.errorAndReloadModalMessage || "",
        translations: state.lang.translations,
    };
};

export default withStyles(styles)(connect(mapStateToProps, {
    setErrorAndReloadModalMessage
})(ChoosePlaceModal)
)